import { render, staticRenderFns } from "./wxAct.vue?vue&type=template&id=5924869e"
import script from "./wxAct.vue?vue&type=script&lang=js"
export * from "./wxAct.vue?vue&type=script&lang=js"
import style0 from "./wxAct.vue?vue&type=style&index=0&id=5924869e&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports